export class SvgChartComponentInterop {
    constructor(svgChartDomElement, svgChartSelectionRectangleDomElement) {
        Object.defineProperty(this, "svgChartDomElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "svgSelectionRectangleDomElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getSvgCoordinates", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                var pt = new DOMPoint(x, y);
                pt = pt.matrixTransform(this.svgChartDomElement.getScreenCTM()?.inverse());
                return { x: pt.x, y: pt.y };
            }
        });
        Object.defineProperty(this, "setSvgSelectionRectXY", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                var { x: offsetX, y: offsetY } = this.getSvgCoordinates(x, y);
                this.svgSelectionRectangleDomElement.setAttribute("x", offsetX.toString());
                this.svgSelectionRectangleDomElement.setAttribute("y", offsetY.toString());
                return offsetX;
            }
        });
        Object.defineProperty(this, "setSvgSelectionRectWidthHeight", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (x, y) => {
                if (x === 0 && y === 0) {
                    this.svgSelectionRectangleDomElement.setAttribute("width", x.toString());
                    this.svgSelectionRectangleDomElement.setAttribute("height", y.toString());
                    return x;
                }
                else {
                    const { x: offsetX, y: offsetY } = this.getSvgCoordinates(x, y);
                    const rectX = this.svgSelectionRectangleDomElement.x.baseVal.value;
                    const rectY = this.svgSelectionRectangleDomElement.y.baseVal.value;
                    const width = offsetX - rectX;
                    const height = offsetY - rectY;
                    if (width >= 0 && height >= 0) {
                        this.svgSelectionRectangleDomElement.setAttribute("width", width.toString());
                        this.svgSelectionRectangleDomElement.setAttribute("height", height.toString());
                    }
                    return offsetX;
                }
            }
        });
        this.svgChartDomElement = svgChartDomElement;
        this.svgSelectionRectangleDomElement = svgChartSelectionRectangleDomElement;
    }
}
